export default "__VITE_ASSET__CTY6oDqv__"